var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('navbar')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"202px"}},[_c('sidebar')],1),_vm._v(" "),_c('el-main',[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("Powered by iCTR_TB!")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }